import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import EmptyPlaceholder from "../../../components/EmptyPlaceholder/EmptyPlaceholder";
import LazyReceivedGiftCard from "./LazyReceivedGiftCard";
import { listGiftsByGiftTableID } from "../../../services/giftApiService";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_MyGiftTable_components_ReceivedGiftsContent";

const ReceivedGiftsContent: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const giftTableId = useSelector((state: RootState) => state.giftTable.ID);

  const [giftIds, setGiftIds] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (giftTableId) {
      setLoading(true);
      listGiftsByGiftTableID(giftTableId, true)
        .then((fetchedGiftIds) => {
          setGiftIds(fetchedGiftIds as string[]);
          setError(null);
        })
        .catch((err) => {
          console.error("Error loading gift IDs", err);
          setError(t("errorLoadingGifts"));
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [giftTableId, t]);

  if (loading) {
    return <div>{t("loading")}</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!giftIds.length) {
    return (
      <EmptyPlaceholder
        title={t("emptyTitle")}
        description={t("emptyDescription")}
      />
    );
  }

  return (
    <div className="p-4">
      <div className="space-y-4 w-full">
        {giftIds.map((id) => (
          <LazyReceivedGiftCard key={id} giftId={id} />
        ))}
      </div>
    </div>
  );
};

export default withTranslations(LOCALE)(ReceivedGiftsContent);
